import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { EditOutlined } from "@ant-design/icons";
import AdminName from "./AdminName";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import AdminUniqueId from "./AdminUniqueId";
import AdminMobile from "./AdminMobile";
import AdminEmail from "./AdminEmail";
import AdminUserName from "./AdminUsename";
import AdminPassword from "./AdminPassword";
import ChangePasswordOnLogin from "./ChangePasswordLogin";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getOrganizationAdmin,
  getOrganizationAdminRequest,
  upsertOrganizationAdmin,
  upsertOrganizationAdminClear,
  upsertOrganizationAdminRequest } from
"@src/redux";
import { getUuid } from "@src/helpers/functions";
import toast from "react-hot-toast";

interface AdminFormProps {
  mutationType: "edit" | "add";
  onCancel: () => void;
  item: any;
}
interface mobileObject {
  number?: string;
  country_code?: string;
  country_short_code?: string;
}

const AdminForm: React.FC<AdminFormProps> = ({
  mutationType,
  onCancel,
  item
}) => {
  const [isPasswordPresent, setIsPasswordPresent] =
  useState<boolean>(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [mobile, setMobile] = useState<mobileObject>({});
  const { result: getOneOrganization } = useSelector(getOrganizationAdmin);
  const {
    result: updateOrganizationResult,
    loading: updateOrganizationLoading
  } = useSelector(upsertOrganizationAdmin);

  const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const password = event.target.value;
    setIsPasswordPresent(!!password);
    if (!password) {
      form.setFieldsValue({ changePasswordOnLogin: false });
    }
  };

  const handleChangeNumber = (values: {
    number: string;
    country_code: string;
    country_short_code: string;
  }) => {
    setMobile(values);
  };

  const onFinish = (values: any) => {
    delete values.changePasswordOnLogin;
    if (getOneOrganization?.systemUser?.username) {
      delete values?.systemUser?.username;
    }
    values.mobile = mobile;
    let newId = getUuid();
    dispatch(
      upsertOrganizationAdminRequest({
        id: getOneOrganization?.id || newId,
        data: {
          ...values,
          id: newId,
          organizationId: item?.id
        }
      })
    );
  };

  useEffect(() => {
    if (item?.id) {
      dispatch(getOrganizationAdminRequest({ id: item?.id }));
    }
  }, [item?.id]);

  useEffect(() => {
    if (getOneOrganization?.id) {
      setMobile({
        number: getOneOrganization?.mobile?.number,
        country_code: getOneOrganization?.mobile?.country_code,
        country_short_code: getOneOrganization?.mobile?.country_short_code
      });
      form.setFieldsValue({
        ...getOneOrganization,
        mobile: getOneOrganization?.mobile ?
        `${getOneOrganization?.mobile?.country_short_code} ${getOneOrganization?.mobile?.country_code} ${getOneOrganization?.mobile?.number}` :
        "",
        systemUser: {
          username:
          getOneOrganization?.systemUser?.username?.split("~")?.[1]
        }
      });
    } else {
      form.resetFields();
    }
  }, [getOneOrganization]);

  useEffect(() => {
    if (updateOrganizationResult?.status === "success") {
      toast.success(t("client_updated_successfully"));
      dispatch(upsertOrganizationAdminClear());
      onCancel();
    } else if (updateOrganizationResult?.error?.message) {
      toast.error(updateOrganizationResult?.error?.message);
      dispatch(upsertOrganizationAdminClear());
    }
  }, [updateOrganizationResult]);

  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      {/* {mutation_type === "edit" && ( */}
      <Row gutter={16} justify="center" align="middle">
        <img
          className="edit-role-image"
          src={USER_PROFILE}
          alt="User Profile" />
        
        <EditOutlined className="edit-avatar-icon" />
      </Row>
      {/* )} */}

      <Row gutter={16}>
        <Col span={12}>
          <AdminName />
        </Col>
        <Col span={12}>
          <AdminUniqueId />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <AdminMobile onChange={handleChangeNumber} />
        </Col>
        <Col span={12}>
          <AdminEmail />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <AdminUserName
            mutationType={mutationType}
            username={getOneOrganization?.systemUser?.username} />
          
        </Col>
        <Col span={12}>
          <AdminPassword
            onPasswordChange={onPasswordChange}
            mutationType={mutationType}
          />
        </Col>
      </Row>
      <Row gutter={16} justify="center" align="middle">
        <Col span={24}>
          <ChangePasswordOnLogin isEnabled={isPasswordPresent} />
        </Col>
      </Row>
      <div className="admin_form_buttons">
        <Button onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type={"primary"}
          htmlType="submit"
          loading={updateOrganizationLoading}>
          
          {getOneOrganization?.id ? t("update") : t("save")}
        </Button>
      </div>
    </Form>);

};

export default AdminForm;